'use client'
import {
  useTicketing
} from "./chunk-POZFG435.mjs";
import {
  useBooking_default
} from "./chunk-NFYYQXAH.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/booking/seats/SeatsChart.tsx
import { useGetHoldToken } from "@wbk/api/hooks";
import { useRouter } from "@wbk/config";

// src/components/booking/seats/SeatsCloudChart.tsx
import { useEffect } from "react";
import { loadScriptAsync } from "@wbk/utils";
import { jsx } from "react/jsx-runtime";
var SeatsCloudChart = (props) => {
  const { seats } = useTicketing();
  useEffect(() => {
    loadScriptAsync({
      id: "seats-planner-script",
      url: "https://chart.seatsplanner.com/v1.0/chart.js"
    }).then(() => {
      var _a;
      if (!window.seats) {
        throw new Error("SeatsCloudChart is not initiated");
      }
      window.seats.adapters.SIO(__spreadProps(__spreadValues({}, props), { workspaceKey: (_a = seats.workspace) == null ? void 0 : _a.seatCloud, divId: "seats-cloud-chart" })).render();
    }).catch(() => {
    });
  }, []);
  return /* @__PURE__ */ jsx("div", { id: "seats-cloud-chart", className: "h-full w-full" }, props.event);
};
var SeatsCloudChart_default = SeatsCloudChart;

// src/components/booking/seats/SeatsIOChart.tsx
import { SeatsioSeatingChart } from "@seatsio/seatsio-react";
import { jsx as jsx2 } from "react/jsx-runtime";
var SeatsIOChart = (props) => {
  var _a;
  const { seats } = useTicketing();
  const { onSeatsInitialized, removeAllSeats } = useBooking_default();
  return /* @__PURE__ */ jsx2(
    SeatsioSeatingChart,
    __spreadProps(__spreadValues({}, props), {
      workspaceKey: (_a = seats.workspace) == null ? void 0 : _a.seatIO,
      onSessionInitialized: (session) => {
        removeAllSeats();
        onSeatsInitialized({ expiresInSeconds: session.expiresInSeconds });
      }
    })
  );
};
var SeatsIOChart_default = SeatsIOChart;

// src/components/booking/seats/SeatsChart.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var SeatsChart = (_a) => {
  var _b = _a, { provider = "seats_io" } = _b, props = __objRest(_b, ["provider"]);
  const { locale } = useRouter();
  const { event, isSeason } = useBooking_default();
  const { data, isLoading } = useGetHoldToken(
    __spreadProps(__spreadValues({}, isSeason ? { season_id: event == null ? void 0 : event._id } : { event_id: event == null ? void 0 : event._id }), {
      locale
    }),
    { enabled: !!(event == null ? void 0 : event._id) }
  );
  if (isLoading)
    return null;
  return provider === "seats_planner" ? /* @__PURE__ */ jsx3(SeatsCloudChart_default, __spreadProps(__spreadValues({}, props), { holdToken: data == null ? void 0 : data.token, session: (event == null ? void 0 : event._id) ? "manual" : "none" })) : /* @__PURE__ */ jsx3(SeatsIOChart_default, __spreadProps(__spreadValues({}, props), { holdToken: data == null ? void 0 : data.token, session: (event == null ? void 0 : event._id) ? "manual" : "none" }));
};
var SeatsChart_default = SeatsChart;

export {
  SeatsChart_default
};
//# sourceMappingURL=chunk-F7WCXMYZ.mjs.map